import { createContext, useState, useContext, useEffect } from "react";

const ProfileFormContext = createContext();

export const useProfileForm = () => useContext(ProfileFormContext);

const LOCAL_STORAGE_KEY = "profileFormData";

const defaultFormData = {
  description: "",
  business_hours: [
    { day: "Sunday", is_open: false },
    { day: "Monday", is_open: true, open_time: "09:00", close_time: "18:00" },
    { day: "Tuesday", is_open: true, open_time: "09:00", close_time: "18:00" },
    { day: "Wednesday", is_open: true, open_time: "09:00", close_time: "18:00" },
    { day: "Thursday", is_open: true, open_time: "09:00", close_time: "18:00" },
    { day: "Friday", is_open: true, open_time: "09:00", close_time: "18:00" },
    { day: "Saturday", is_open: true, open_time: "10:00", close_time: "16:00" },
  ],
  country: "",
  city: "",
  state: "",
  zip_code: "",
  location: "",
  address: "",
  currentPage: 1,
};

export const ProfileFormProvider = ({ children }) => {
  const [formData, setFormData] = useState(null); // Start with null
  const [isLoaded, setIsLoaded] = useState(false);

  const updateForm = (newData) => {
    setFormData((prev) => ({ ...prev, ...newData }));
  };

  // Load data from localStorage on first render
  useEffect(() => {
    const saved = localStorage.getItem(LOCAL_STORAGE_KEY);
    if (saved) {
      try {
        const parsedData = JSON.parse(saved);
        setFormData(parsedData);
      } catch (e) {
        console.error("Invalid form data in localStorage");
        setFormData(defaultFormData);
      }
    } else {
      setFormData(defaultFormData);
    }
    setIsLoaded(true);
  }, []);

  // Sync to localStorage whenever formData changes (but only after initial load)
  useEffect(() => {
    if (isLoaded && formData) {
      localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(formData));
    }
  }, [formData, isLoaded]);

  const clearForm = () => {
    setFormData(defaultFormData);
    localStorage.removeItem(LOCAL_STORAGE_KEY);
  };

  // Don't render children until data is loaded
  if (!isLoaded || !formData) {
    return <div>Loading...</div>; // Or your loading component
  }

  return <ProfileFormContext.Provider value={{ formData, updateForm, clearForm, isLoaded }}>{children}</ProfileFormContext.Provider>;
};
